<script setup lang="ts">
import { computed } from "vue";

import { cardActions } from "@/action/cardActions";
import { cardKey } from "@/components/StickyNote/injectKeys";
import { boardKey } from "@/components/board/injectKeys";
import ActionMenuDropdown from "@/components/menu/ActionMenu/ActionMenuDropdown.vue";
import { isBacklogBoard } from "@/model/board";
import { isTeamLevelWorkitem } from "@/model/stickyType";
import { useWorkModeStore } from "@/store/workMode";
import { toElipsis } from "@/utils/string";
import { injectStrict } from "@/utils/vue";

import SetStoryPoints from "./SetStoryPoints.vue";

const card = injectStrict(cardKey);
const board = injectStrict(boardKey);

const points = computed(() => card.points + "");
const visible = computed(() => {
  // show it only for work items
  // shot it only to for stickies that were created on the team board
  if (!isTeamLevelWorkitem(card)) {
    return false;
  }
  // hide it on backlog board
  if (isBacklogBoard(board.value.type)) return false;
  // show it only in execution mode
  return useWorkModeStore().isExecutionMode;
});
</script>

<template>
  <ActionMenuDropdown
    v-if="visible"
    :action="cardActions.setPoints"
    :tooltip="$t('cardAction.storyPoints', { points })"
    width="auto"
  >
    <template #content>
      <span class="story-points-item">
        <span aria-hidden="true">{{ toElipsis(points) }}</span>
        <span class="screen-reader-only">{{ $t("cardAction.storyPoints", { points }) }}</span>
      </span>
    </template>
    <SetStoryPoints />
  </ActionMenuDropdown>
</template>

<style lang="scss" scoped>
@use "@/styles/mixins/a11y";
@use "@/styles/mixins/typography";
@use "@/styles/variables/colors";

.story-points-item {
  @include typography.small("bold");

  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
  background-color: colors.$background-ui;
  border-radius: 4px;
  color: colors.$text;
}

.screen-reader-only {
  @include a11y.screen-reader-only;
}
</style>
